import { useApi } from "../../../libs/shared/hooks/useApi";

export const useReservationPaymentUrl = (reservationId: number) =>
  useApi<{ url: string }, undefined>(
    `/v1/payments/reservation/${reservationId}`
  );
